import script from "./usb-device-type-distribution-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./usb-device-type-distribution-chart.vue?vue&type=script&lang=ts&setup=true"

import "./usb-device-type-distribution-chart.vue?vue&type=style&index=0&id=60370980&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60370980"]])

export default __exports__